import { Inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  isLoading = false;
  private hasStartedLoading = false;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  setLoading(isLoading: boolean) {
    this.isLoading = isLoading;
    if (isLoading) {
      this.hasStartedLoading = true;
      this.document.body.removeAttribute('data-report-ready');
      console.log('[AppService] setLoading(true) — clearing data-report-ready');
    } else if (this.hasStartedLoading) {
      this.document.body.setAttribute('data-report-ready', 'true');
      console.log('[AppService] setLoading(false) — data-report-ready set; headless renderer may now capture');
    } else {
      console.log('[AppService] setLoading(false) called before any setLoading(true) — ignoring');
    }
  }
}
